import React from 'react';
import { connect } from 'react-redux';
import OpacitySetting from './opacitySetting';
import RoadLabelSwitch from '../roadLabelSwitch';
import MetricsSwitch from '../metricsSwitch';
import { _ } from '../../../functions/translator';
import AddCosts from '../addCosts';
import AxlesSwitch from '../axlesSwitch';
import AddBreakContainer from '../../map/AddBreak/addBreakContainer';

function SettingTab(props) {
    return (
        <div
            role="tabpanel"
            hidden={props.tabIndex !== props.index}
        >
            <p>{_('Configuración')}:</p>
            <AxlesSwitch></AxlesSwitch>
            <RoadLabelSwitch/>
            {props.userRole.project_dashboard && <MetricsSwitch/>}
            {props.userRole.add_progress_update && <AddCosts editMode={false} />}
            <OpacitySetting/>
            {(props.userRole.lineal && props.userRole.add_card) && <AddBreakContainer/>}
        </div>
    );
}

function mapStateToProps(state) {
    return {
        userRole: state.userRole,
    }
}

export default connect(mapStateToProps)(SettingTab);
